(function () {
  const resolveWrapper = (target) => {
    if (!target) return null;
    if (target.id?.startsWith("shopify-section-")) return target;
    return target.closest('[id^="shopify-section-"]');
  };

  const resolveScope = (target) => {
    const wrapper = resolveWrapper(target);
    if (!wrapper) return null;
    return wrapper.querySelector(".image-collage-section") || wrapper;
  };

  const initSection = (target) => {
    const wrapper = resolveWrapper(target);
    const scope = resolveScope(target);
    if (!wrapper || !scope) return;

    initParallax(wrapper, scope);
    initHeadingAnimation(wrapper, scope);
  };

  const initParallax = (wrapper, scope) => {
    const columns = scope.querySelectorAll(".image-collage-column");
    const leftColumn = columns[0];
    const rightColumn = columns[columns.length - 1];
    if (!leftColumn || !rightColumn || columns.length < 2) return;

    const updateParallax = () => {
      if (window.innerWidth <= 576) {
        leftColumn.style.transform = "";
        rightColumn.style.transform = "";
        return;
      }

      const rect = wrapper.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.bottom < 0 || rect.top > windowHeight) return;

      const scrollProgress = Math.max(
        0,
        Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height))
      );
      const maxOffset = 150;
      const leftOffset = maxOffset * scrollProgress;
      const rightOffset = -maxOffset * scrollProgress;
      leftColumn.style.transform = `translateY(${leftOffset}px)`;
      rightColumn.style.transform = `translateY(${rightOffset}px)`;
    };

    updateParallax();

    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    });
    window.addEventListener("resize", updateParallax);
  };

  const initHeadingAnimation = (wrapper, scope) => {
    const enableAnimation = scope.querySelector("[data-enable-header-animation]");
    if (!enableAnimation) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapper.classList.add("anim-active");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );

    observer.observe(scope);
  };

  const initAll = () => {
    document
      .querySelectorAll('script[data-section-id][src*="image-collage.js"]')
      .forEach((script) => {
        const sectionId = script.dataset.sectionId;
        if (!sectionId) return;
        const wrapper = document.getElementById(`shopify-section-${sectionId}`);
        initSection(wrapper);
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:select", (event) => {
    initSection(event.target);
  });
})();
